<template>
    <div>
        <form @submit.prevent="submitForm">
            <div class="row">
                <div class="col-sm-12 col-md-6 border-right">
                    <div class="form-group">
                        <label class="form-label">{{$t('label.title')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-text"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('table.header.caption')}}</label>
                        <textarea class="form-control" :placeholder="$t('table.header.caption')" rows="5" v-model="caption"></textarea>
                    </div>
                    <div class="form-group mb-1">
                        <label class="form-label">{{$t('label.contact')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-phone-alt"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="contact" @keyup="contactValidation">
                        </div>
                        <div id="err" class="error-validation"></div>
                    </div>
                    <div class="help-block fs-xs">
                        <p class="mb-0">{{$t('message.contact_validation.notes')}}</p>
                        <ul>
                            <li>{{$t('message.contact_validation.my')}} 601x xxx xxxx</li>
                            <li>{{$t('message.contact_validation.sg')}} 65x xxx xxxx</li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <h6 class="text-dark fw-500">{{$t('table.header.image')}}:</h6>
                    <div id="imageContainer" v-if="image != ''" class="text-center mt-3">
                        <div class="text-right mb-2 mr-2">
                            <button v-show="!dzShow" class="btn btn-sm btn-outline-primary" type="button" :title="$t('header.delete_image')" @click="showModal">
                                <span class="fal fa-trash" ></span>
                            </button>
                        </div>
                        <img class="img-fluid img-thumbnail" :src="image"/>
                    </div>
                    <div v-else>
                        <vue-dropzone ref="dropzone" class="text-center" id="dropLogo" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                    </div>
                    <div v-if="dzShow" class="mt-2"> 
                        <div class="row">
                            <div class="col">
                                <h6 class="text-dark fs-sm">{{$t('header.upload_image')}}: </h6>
                            </div>
                            <div class="col text-right">
                                <a id="uploadCancel" class="cancel link" @click="handleDropzone('item-image')">{{$t('button_link.cancel')}}</a>
                            </div>
                        </div>
                        <vue-dropzone ref="dropzone" class="text-center" id="dropLogo" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                    </div>
                </div>
            </div>
            <div class="border-top pt-3 mt-3 mb-3">
                <div class="row">
                    <div class="col-6">
                        <button v-if="!isEdit" type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnParent">{{$t('button_link.cancel')}}</button>
                        <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                    </div>
                </div>
            </div>
        </form>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal.vue'
import vueDropzone from "vue2-dropzone";
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {contactValidation} from './../../../../assets/js/dashboard/utilities'
export default {
    name: 'broadcastForm',
    props:{
        isEdit: Boolean
    },
    components:{
        vueDropzone, DeleteModal
    },
    data(){
        return{
            bCastID: 0, 
            title: "", caption: "", contact: "", image: "",
            dzShow: false,
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            },
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                if(this.$refs.deleteModal.toggleModal){
                    this.$refs.deleteModal.toggleModal = false
                }else if(this.dzShow){
                    this.dzShow = false
                }else{
                    this.$emit('returnParent')
                }
            }
            this.$parent.$parent.isModalShow = false
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.upload'));
            }else{
                this.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.success.upload'));
                this.image = response.path
            }
            this.dzShow = true
        },
        contactValidation(){
            var err = contactValidation(this.contact);
            document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        showModal(){
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        returnParent(){
            this.$emit('returnParent')
            this.title = this.caption = this.contact = this.image = ""
        },
        deleteImage(){
            this.image = ""
            this.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.success.delete_image'))
        },
        editForm(item){
            this.bCastID = item.bcastID
            this.title = item.title
            this.caption = item.caption
            this.contact = item.contact
            this.image = item.path
        },
        submitForm(){
            var data = {
                path: this.image,
                title: this.title, 
                caption: this.caption,
                contact: this.contact
            }

            let url = this.$api.BROADCAST + (this.isEdit ? "/" + this.bCastID + this.$api.UPDATE : '')
            let $vm = this;

            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.my_salon_broadcast') +  $vm.$i18n.t('message.success.success', {'action': $vm.isEdit ? $vm.$i18n.t('message.success.action.update') : $vm.$i18n.t('message.success.action.add')})
                    $vm.$parent.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        async getContact(){
            let $vm = this;
            var result = {}

            await $vm.$axios({
                method: 'get', 
                url: $vm.$api.BRAND_SETTING,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result= response.data;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result.contact
        }
    },
    async mounted(){
        let $vm = this
        $vm.contact = await $vm.getContact()
    }
}
</script>
<style scoped>
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>